/** Hakkımızda metinleri */
export const aboutParagraphs = [
  "Arte Mülk Yönetimi ve Danışmanlık olarak kullanıcılara, mal sahiplerine, gayrimenkul yatırımcılarına ve geliştiricilere gayrimenkul alanında aracılık, danışmanlık ve portföy yönetim hizmetleri vermektedir.",
  "Arte Mülk Yönetimi ve Danışmanlık, kurum ve kuruluşların portföylerindeki gayrimenkullerinin analizi, yönetim planlaması ve stratejilerinin belirlenmesi, pazarlama ve satış stratejileri kararlarının alınıp geliştirilen modellerle gayrimenkullerinin satışının sağlanarak firmalara kaynak sağlamaktadır.",
  "Arte Mülk Yönetimi ve Danışmanlık bünyesinde yer alan artemulk.com altyapısı ile kurumsal ve bireysel düzeyde, objektif varlık satışlarının yapılabileceği, alıcıların doğru şekilde analiz edilmiş bilgiler ışığında satın alma yapabilecekleri bir online satın alma platformu hizmeti de sunmaktadır.",
];

/** Vizyon & Misyon */
export const visionMissionParagraphs = [
  "Arte Mülk Yönetimi olarak vizyonumuz, gayrimenkul sektöründe veri odaklı, yenilikçi ve sürdürülebilir çözümlerle sektördeki liderliğimizi pekiştirmek ve müşterilerimize en yüksek değeri sunmaktır. Müşterilerimizin gayrimenkul yatırımlarını en verimli şekilde yöneterek, onların uzun vadeli başarılarını güvence altına almak, aynı zamanda pazardaki trendleri takip ederek, sektördeki gelişmeleri önceden öngörüp stratejik fırsatlar yaratmak en büyük hedefimizdir. Teknolojik yenilikleri ve dijital çözümleri kullanarak, şeffaf, güvenilir ve sürdürülebilir mülk yönetimi çözümleri sunarak, tüm müşterilerimize üstün hizmet kalitesi sağlamayı amaçlıyoruz.",
  "Gayrimenkul piyasasında, arz-talep dengelerini, pazar analizlerini ve bölgesel dinamikleri dikkate alarak, her bir mülk için özel çözümler sunuyoruz.",
  "Gayrimenkul yönetiminde şeffaflık, güven ve profesyonellik ilkelerine bağlı kalarak, her türlü mülk yönetimi ihtiyacını en verimli şekilde karşılıyoruz. Ayrıca, dijital araçlar ve yazılımlar kullanarak, hızlı ve doğru çözümlerle mülklerin değerini artırıyor ve pazarda güçlü bir konum elde etmelerini sağlıyoruz.",
];

export const siteTagline = "Doğru Yatırım, Güvenli Gelecek";
export const siteName = "Arte Mülk Yönetimi";
export const siteUrl =
  process.env.REACT_APP_SITE_URL || "https://artemulk.com";
export const apiBaseUrl =
  process.env.REACT_APP_API_URL || "https://api.artemulk.com/api";
export const apiOrigin = apiBaseUrl.replace(/\/api\/?$/, "");

export { branchImageUrls, getBranchImage } from "./branchImages";

/** Sayfa ve şube görselleri — her bölümde farklı dosya (tekrar yok) */
export const artemulkImages = {
  logo: "/artemulk/img/artemulk-logo.png",
  logoMark: "/artemulk/img/logo-mark.png",
  favicon: "/artemulk/img/favicon-mark.png",
  /** Anasayfa üst banner */
  heroBackground: "/artemulk/img/background.jpg",
  /** İlanlar sekmesi — şehir / konut silüeti (tüm ilanlar) */
  listingsHero: "/artemulk/img/hero-listings.jpg?v=6",
  /** Satılık ilanlar sayfası banner */
  saleHero: "/artemulk/img/hero-satilik.jpg",
  /** Kiralık ilanlar sayfası banner */
  rentHero: "/artemulk/img/hero-kiralik.jpg",
  /** Hakkımızda sayfa üst kapak */
  pageCover: "/artemulk/img/hero-about.jpg",
  /** Tanıtım videosu bölümü arka planı */
  videoBackground: "/artemulk/img/hero-video.jpg",
  /** İletişim sayfa üst kapak */
  contactCover: "/artemulk/img/advert1.png",
  aboutMain: "/artemulk/img/about-main.jpg",
  aboutAccent: "/artemulk/img/advert5.png",
  visionMission: "/artemulk/img/about2.jpg",
  contactForm: "/artemulk/img/advert6.png",
  branch: {
    istanbul: "/artemulk/img/branches/istanbul.jpg",
    izmir: "/artemulk/img/branches/izmir.jpg",
    balikesir: "/artemulk/img/branches/balikesir.jpg",
    bandirma: "/artemulk/img/branches/bandirma.jpg",
    bodrum: "/artemulk/img/branches/bodrum.jpg",
  },
};

/** Anasayfa — her türden gösterilecek ilan sayısı */
export const HOME_LISTINGS_PER_TYPE = 4;

/** Anasayfa ilan bölümleri (kategori / işlem türü) */
export const homeListingSections = [
  {
    id: "konut",
    title: "Konut",
    to: "/house",
    match: (item) => item.categoryTypeName === "Konut",
  },
  {
    id: "arsa",
    title: "Arsa",
    to: "/land",
    match: (item) => item.categoryTypeName === "Arsa",
  },
  {
    id: "isyeri",
    title: "İş Yeri",
    to: "/workplace",
    match: (item) => item.categoryTypeName === "İşyeri",
  },
  {
    id: "turistik",
    title: "Turistik",
    to: "/touristy",
    match: (item) => item.categoryTypeName === "Turistik tesis",
  },
  {
    id: "kiralik",
    title: "Kiralık",
    to: "/rent",
    match: (item) => item.tradeTypeName === "Kiralık",
  },
  {
    id: "satilik",
    title: "Satılık",
    to: "/sale",
    match: (item) => item.tradeTypeName === "Satılık",
  },
];

/** Anasayfa kategori kartları — her kategori kendi görseli */
export const listingCategories = [
  { id: "konut", name: "Konut", image: "/artemulk/img/category-konut.jpg?v=2", to: "/house" },
  { id: "arsa", name: "Arsa", image: "/artemulk/img/category-arsa.jpg?v=hd", to: "/land" },
  { id: "isyeri", name: "İş Yeri", image: "/artemulk/img/category-isyeri.jpg", to: "/workplace" },
  { id: "turistik", name: "Turistik", image: "/artemulk/img/category-turistik.jpg", to: "/touristy" },
  { id: "kiralik", name: "Kiralık", image: "/artemulk/img/category-kiralik.jpg?v=3", to: "/rent" },
  { id: "satilik", name: "Satılık", image: "/artemulk/img/category-satilik.jpg?v=3", to: "/sale" },
];

/** İlan listesi üst banner — sayfa türüne göre */
export const getListingsHeroImage = (trade) => {
  if (trade === "Kiralık") return artemulkImages.rentHero;
  if (trade === "Satılık") return artemulkImages.saleHero;
  return artemulkImages.listingsHero;
};

/** Şube e-postaları */
export const branchEmails = {
  istanbul: "istanbul@artemulk.com",
  izmir: "izmir@artemulk.com",
  balikesir: "balikesir@artemulk.com",
  bandirma: "bandirma@artemulk.com",
  bodrum: "bodrum@artemulk.com",
};

/** TR telefon → uluslararası (WhatsApp / tel link) */
export const toIntlPhone = (phone) => {
  let digits = phone.replace(/\D/g, "");
  if (digits.startsWith("0")) digits = `9${digits}`;
  else if (!digits.startsWith("90")) digits = `90${digits}`;
  return digits;
};

/** Şube telefonları (Hakkımızda kartlarında da kullanılır) */
export const branchPhones = {
  istanbul: "",
  izmir: "0850 466 70 48",
  balikesir: "0262 713 10 10",
  bandirma: "0262 713 10 10",
  bodrum: "0532 471 78 93",
};

export const mainContact = {
  /** Genel iletişim / Şimdi Ara hattı */
  phone: branchPhones.izmir,
  /** Emlakjet / bölge hattı (İzmir şubesi) */
  phoneAlt: branchPhones.izmir,
  /** WhatsApp — Bodrum cep (0532) */
  whatsapp: process.env.REACT_APP_WHATSAPP_PHONE || branchPhones.bodrum,
  email: branchEmails.istanbul,
  address:
    "Hasanpaşa Mahallesi, Uzunçayır Caddesi, No: 61, Kat: 1, İşyeri No: 2, Kadıköy / İstanbul",
};

export const whatsappUrl = (message = "") => {
  const num = toIntlPhone(mainContact.whatsapp);
  const base = `https://wa.me/${num}`;
  return message ? `${base}?text=${encodeURIComponent(message)}` : base;
};

/**
 * Kurumsal tanıtım videosu (YouTube video ID).
 * Anasayfada tanıtım videosu yalnızca youtubeId tanımlıysa gösterilir.
 * Gerçek Arte Mülk videosu varsa ID'yi buraya yazın (ör. "dQw4w9WgXcQ").
 */
export const promoVideo = {
  youtubeId: process.env.REACT_APP_PROMO_YOUTUBE_ID || "",
  thumbnail: "/artemulk/img/adverts/4.webp",
};
